import './WfmIframe.css'

export default function WfmIframe() {
    const wfmURL = import.meta.env.VITE_WFM_URL;
    
    return (
        <iframe
            title="wfm"
            width="100%"
            height="100%"
            src={wfmURL}
            style={{ border: "none" }}
        />
    )
}
